import { useState } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { removePetitionFromMovement } from 'src/app/pages/movement/shared/api';

type RemovePetitionSuccess = { description: boolean } | undefined;
type RemovePetitionError = { message: string } | undefined;

export type RemovePetitionResult = {
	remove: (petitionId: string, movementId: string) => Promise<boolean>;
	success?: RemovePetitionSuccess;
	error?: RemovePetitionError;
	loading: boolean;
};

export function useRemovePetitionFromMovement(): RemovePetitionResult {
	const utilityContext = useUtilityContext();

	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<RemovePetitionError>(undefined);
	const [success, setSuccess] = useState<RemovePetitionSuccess>(undefined);

	const remove = async (petitionId: string, movementId: string) => {
		try {
			setSuccess(undefined);
			setError(undefined);
			setLoading(true);
			const response = await removePetitionFromMovement(petitionId, movementId, utilityContext);
			setSuccess({ description: response });
			return true;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			// FIXME: There is no real error handling here and errors are just being hidden
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
			setError({ message: e.message });
			return false;
		} finally {
			setLoading(false);
		}
	};
	// FIXME: Those values are not used
	return { remove, success, error, loading };
}
